import type { InvoiceApproval } from "../@types/services/InvoiceApproval";
import { api } from "./api";

const API_BASE_URL = "/api/v2";

export const fetchInvoiceApproval = async (
  id: string,
): Promise<InvoiceApproval> => {
  const response = await api.get(`/invoice_approvals/${id}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

type InvoiceApprovalUpdate = {
  status: "approved" | "rejected";
  comment: string;
};

export const updateInvoiceApproval = async (
  id: string,
  data: InvoiceApprovalUpdate,
): Promise<InvoiceApproval> => {
  const response = await api.put(`/invoice_approvals/${id}`, data, {
    baseURL: API_BASE_URL,
  });
  return response.data;
};
